module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_9016.67f96172.png";